import { AuthUser } from '@app/core/types/users';
import { UserRole } from '@mi-front/core';
import debugFn from 'debug';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useImpersonation } from './useImpersonationStore';

export const debug = debugFn('auth:impersonation');

/**
 * Hook that requires that if an admin is logged in, a user to
 * impersonate must be selected before accessing any screen.
 * Tab-scoped `auth_as` (backoffice deep links) also satisfies the lock.
 */

export function useSuperadminLock(user?: AuthUser) {
  const { authAsUserId } = useImpersonation();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (!user) {
      return;
    }

    // Redirect when a superadmin has neither a tab override nor a persisted user,
    // and we're not already on the admin page (avoids an infinite redirect).
    if (
      user.role === UserRole.SUPERADMIN &&
      !authAsUserId &&
      location.pathname !== '/settings/impersonation'
    ) {
      debug('No impersonated user selected, redirecting to impersonation screen');
      history.push('/settings/impersonation');
    }
  }, [user, authAsUserId, history, location.pathname]);
}
